import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PostMessageService {
  public postClientHeight(eventName: 'init' | 'next' | 'back' | 'modal', clientHeightPx: number) {
    this.postMessage(eventName, { clientHeight: clientHeightPx });
  }

  public postExternalLink(href: string) {
    this.postMessage('externalLink', { href });
  }

  public postInstanceId(instanceId: string) {
    this.postMessage('instanceId', { instanceId });
  }

  public postStatus(status: 'skip' | 'complete' | 'cancel' | 'saveAndExit') {
    this.postMessage(status);
  }

  public postMessage(eventName: string, supplementalData: { [key: string]: string | number } = {}) {
    if (window) {
      if (window.opener) {
        window.opener.postMessage({ event: eventName, ...supplementalData }, '*');
      } else {
        window.parent.postMessage({ event: eventName, ...supplementalData }, '*');
      }
    }
  }
}
